import { managementTestInstance } from '../axios';

const getUserPermissions = () => managementTestInstance.post('/my-permissions');

export default getUserPermissions;
